export const throwResponseError = async (res: Response): Promise<never> => {
  const err = (await res.json().catch(() => ({}))) as { error?: string };
  throw new Error(err?.error ?? res.statusText);
};
